import { RadioGroupProps } from "./InputProps";

import RadioButton from "./RadioButton";

const RadioGroup: React.FC<RadioGroupProps> = ({ currentSelection, setCurrentSelection, fieldsetId, fields }) => {
    const renderRadioButtons = () => {
        return fields.map((field) => {
            return (
                <RadioButton
                    name={`fieldset_${fieldsetId}`}
                    checked={currentSelection === field.id}
                    handleFieldChange={() => setCurrentSelection(field.id)}
                    field={field}
                    key={field.id}
                />
            );
        });
    };

    return <>{fields?.length > 0 && renderRadioButtons()}</>;
};

export default RadioGroup;
